export default __webpack_public_path__ + "static/media/53-MonteCarlo.125cf318.jpg";